import Subject from "../cse4sub/Subject";
import React from 'react'
import csm from '../assets/CSEASH205mid21.pdf'
import cse from '../assets/CSEASH205end21.pdf'

export default function ENG_2() {
  return (
    <div>
       <Subject title="Communicative Skill in English(ASH205)" mid="Q. Paper"
    book1="Marks, Jonathan. English Pronunciation in Use: Elementary. CUP, 2008." book2=" "
    book1Link="https://www.pdfdrive.com/download.pdf?id=184034586&h=debac21b75c4ef9861a24805412ae34d&u=cache&ext=pdf" 
    book2Link="#" int21="#" mid21={csm} end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}